import React, { useEffect, useState, useRef } from "react";
import ModernDatePicker from "../components/ui/ModernDatePicker";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseURL, server_API, server_django_api } from "../config";
import { TailSpin } from "react-loader-spinner";
import "react-quill/dist/quill.bubble.css";
import ReactQuill from "react-quill";
import ReactCountryFlag from "react-country-flag";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import file_upload from "../images/Action Icon Filled.svg";
import cross from "../images/Vector.svg";
import success from "../images/success.png";
import bg from "../images/Bg.png";
import {
  getCurrencySymbol,
  getPhoneCode,
  formatSalary,
} from "../utils/currencyUtils";
import { CURRENCY_PREFIXES } from "../constants/common";

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: currentYear - 1949 }, (_, i) => {
  const year = 1950 + i;
  return { value: year.toString(), label: year.toString() };
});
const Careers = ({ noSource = false }) => {
  const params = useParams();
  const ref = useRef();
  const fileInputRef = useRef(null);
  const [job, setJob] = useState(null);
  const [company, setCompany] = useState({});
  const [isParsed, setIsParsed] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [companyNames, setCompanyNames] = useState(null);
  const [designations, setDesignations] = useState(null);
  const [skillset, setskillset] = useState([]);
  const [err, setErr] = useState(true);
  const [loader, setLoader] = useState(null);
  const [popup, setPopup] = useState(false);
  const [rem1, setRem1] = useState(0);
  const [companyCountryCode, setCompanyCountryCode] = useState("IN"); // Default
  const curr = getCurrencySymbol(companyCountryCode);
  const [twelveHour, setTwelveHour] = useState("");
  const [oneHour, setOneHour] = useState("");
  const [rem2, setRem2] = useState(0);
  const [date, setDate] = useState("");
  const [logo, setLogo] = useState("");
  const [time, setTime] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [d1, setD1] = useState("");
  const [d2, setD2] = useState("");
  const [countryCode, setCountryCode] = useState(getPhoneCode(companyCountryCode));
  const [openInfo, setOpenInfo] = useState(true);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [source, setSource] = useState(noSource ? "Northstarz.ai" : "");
  const [Fifteen, setFifteen] = useState("");
  const [dateFlag, setDateFlag] = useState(false);
  const [filteredTimeOptions, setFilteredTimeOptions] = useState([]);
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [link, setLink] = useState("");
  const [reason, setReason] = useState("");
  const [servicing, setServicing] = useState("");
  const [noticePeriod, setNoticePeriod] = useState("");
  const [currentCtc, setCurrentCtc] = useState("");
  const [expectedCtc, setExpectedCtc] = useState("");
  const [availability, setAvailability] = useState("");
  const [school10, setSchool10] = useState("");
  const [pass10, setPass10] = useState("");
  const [score10, setScore10] = useState("");
  const [school12, setSchool12] = useState("");
  const [pass12, setPass12] = useState("");
  const [score12, setScore12] = useState("");
  const [bachelorInstitute, setBachelorInstitute] = useState("");
  const [bachelorDegree, setBachelorDegree] = useState("");
  const [bachelorYear, setBachelorYear] = useState("");
  const [bachelorScore, setBachelorScore] = useState("");
  const [scoreType10, setScoreType10] = useState("percentage");
  const [scoreType12, setScoreType12] = useState("percentage");
  const [scoreTypeBachelor, setScoreTypeBachelor] = useState("percentage");
  const [score12Error, setScore12Error] = useState("");
  const [bachelorScoreError, setBachelorScoreError] = useState("");
  const [score10Error, setScore10Error] = useState("");
  const [fnameError, setFnameError] = useState(false);
  const [pnumError, setPnumError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [fname, setFname] = useState("");
  const [email, setEmail] = useState("");
  const [pnum, setPnum] = useState("");
  const [add1, setAdd1] = useState("");
  const [add2, setAdd2] = useState("");
  const [pin, setPin] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [locations, setLocations] = useState({
    current: "",
    preffered: [],
  });
  const [country, setCountry] = useState("");
  const [addressLookupFailed, setAddressLookupFailed] = useState(false);
  const [highestQualification, setHighestQualification] = useState("");
  const [emptyRes, setEmptyRes] = useState(false);
  const [jobs, setJobs] = useState("");
  const [companys, setCompanys] = useState("");
  const [currentSalary, setCurrentSalary] = useState("");
  const [expectedSalary, setExpectedSalary] = useState("");
  const [addInfo, setAddInfo] = useState("");
  const [skill, setSkill] = useState("");
  const [editor, setEditor] = useState(false);
  const [viewer, setViewer] = useState(false);
  const [tab, setTab] = useState(0);
  const [experience, setExperience] = useState("");
  const [coverletter, setCoverLetter] = useState(null);
  const [error, setError] = useState(false);
  const [applicantid, setApplicantId] = useState("");
  const [resume, setResume] = useState(null);
  const [jd, setJd] = useState("");
  const [ws, setWs] = useState("");
  const [extraFields, setExtraFields] = useState({});
  const [willingToWork, setWillingToWork] = useState("");
  const [willingToRelocateHyderabad, setWillingToRelocateHyderabad] = useState("");
  const [comfortable7DayRoster, setComfortable7DayRoster] = useState("");
  const [edTechExperience, setEdTechExperience] = useState("");
  const [remoteWork, setRemoteWork] = useState("");
  const [willingToWork5DaysOffice, setWillingToWork5DaysOffice] = useState("");
  const [everestSkillExperiences, setEverestSkillExperiences] = useState({});

  // ACFL specific states
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [pan, setPan] = useState("");
  const [voterId, setVoterId] = useState("");
  const [drivingLicense, setDrivingLicense] = useState("");
  const [equifaxConsent, setEquifaxConsent] = useState(false);
  const [highestQualificationACFL, setHighestQualificationACFL] = useState("");
  const [panError, setPanError] = useState("");
  const [fatherNameError, setFatherNameError] = useState("");
  const [motherNameError, setMotherNameError] = useState("");

  const [educationDetails, setEducationDetails] = useState([
    {
      insName: "",
      courseName: "",
      stDate: "",
      endDate: "",
      score: "",
    },
  ]);
  const hasCountryCode = pnum.includes(countryCode);
  const invalidLength = pnum.length > 0 && pnum.length !== 10;
  const startsWithZero = pnum.startsWith("0") && pnum.length > 0;
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const isValidFileType = (file) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];
    return allowedTypes.includes(file.type);
  };

  const validateScore = (value, format) => {
    if (!value) return "Score is required";

    const num = parseFloat(value);
    if (isNaN(num)) return "Invalid number";

    if (format === "CGPA") {
      if (num < 0 || num > 10) return "CGPA must be between 0 and 10";
      if (!/^\d{1,2}(\.\d)?$/.test(value))
        return "Only 1 decimal place allowed for CGPA";
    } else {
      if (num < 0 || num > 100) return "Percentage must be between 0 and 100";
      if (!/^\d{1,3}(\.\d{1,2})?$/.test(value))
        return "Up to 2 decimal places allowed for percentage";
    }

    return "";
  };
  const todayDate = new Date();
  const datePickerId = new Date().toISOString().split("T")[0];
  const myDate = new Date(new Date().getTime() + 2 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

  useEffect(() => {
    console.log(document.referrer);
  }, []);

  const scroll = () => {
    ref.current.scrollIntoView();
  };

  useEffect(() => {
    if (loader == false && err == false) {
      // navigate('/thankyou')
    }
  }, [loader]);

  const acknowledgement = `By using Northstarz.ai for job applications, you acknowledge and consent to the collection processing, and sharing of your personal data as described below for the job position posted by ${company.name}. 
                            During the application process, we collect information such as your name, contact details, resume, and cover letter. 
                            Video interviews conducted on our platform may be recorded for assessment purposes. These recordings are securely stored and 
                            accessible only to authorized personnel involved in the recruitment process. Your application data, including video interviews, 
                            will be made available with the company you are applying to. Additionally, we may use anonymized and aggregated data (including video interview data) 
                            for system improvement and enhancements to provide better services to both candidates and employers. By agreeing to this consent, you allow us to use collected 
                            data for evaluation in relation to the job position posted by ${company.name} and future product development of the product Northstarz.ai or 
                            for any other product or service, whether existing or to be conceived and/ or developed in future, by Novelio Technologies Private Limited or 
                            it's successors, assigns, partners, subsidiaries, agents or licencees as deemed fit by Novelio Technologies Private Limited.`;

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  console.log(checkbox1, checkbox2);

  useEffect(() => {
    if (rem1 > 0 && rem2 > 0) {
      const reminderDate1 = new Date(
        parseInt(todayDate.getTime()) + parseInt(rem1),
      );
      console.log(reminderDate1.toLocaleDateString());
      setD1(
        `${reminderDate1.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          reminderDate1.toLocaleDateString().split("/")[0],
          2,
        )}-${padWithLeadingZeros(
          reminderDate1.toLocaleDateString().split("/")[1],
          2,
        )}`,
      );

      const reminderDate2 = new Date(parseInt(rem2) + reminderDate1.getTime());
      //
      setD2(
        `${reminderDate2.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          reminderDate2.toLocaleDateString().split("/")[0],
          2,
        )}-${padWithLeadingZeros(
          reminderDate2.toLocaleDateString().split("/")[1],
          2,
        )}`,
      );
    }
  }, [rem1, rem2]);

  console.log(d1);

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Prevent default behavior for drag enter events
  const handleDragEnter = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const droppedFile = e.dataTransfer.files[0];
    if (!droppedFile) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];

    if (allowedTypes.includes(droppedFile.type)) {
      setResume(droppedFile);
    } else {
      alert("Only PDF, DOC, and DOCX files are allowed.");
    }

    setResume(droppedFile);
  };

  function handleDefault() {
    setResume(null);
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setResume(file);
  };

  const checkboxesValid = checkbox1 && checkbox2;
  const requiredEverestSkills = Array.isArray(job?.required_skills)
    ? job.required_skills
    : [];
  const isEverestIMSFlow = !!company?.is_everestIMS;
  const isSocketAIFlow = !!company?.is_socketAI;
  const isValidDecimalExperience = (val) =>
    /^\d+(\.\d+)?$/.test(`${val}`.trim());

  const isBaseValid =
    !!(
      resume &&
      source &&
      isValidEmail &&
      fname.length > 0 &&
      email.length > 0 &&
      pnum.length > 0 &&
      !pnum.includes(countryCode) &&
      !invalidLength &&
      !startsWithZero &&
      locations.preffered?.length > 0 &&
      locations.current?.length > 0 &&
      (source === "Employees referral"
        ? extraFields.employeeName?.length > 0 &&
        extraFields.employeeId?.length > 0
        : source === "Recruitment agency"
          ? extraFields.agencyName?.length > 0
          : true)
    ) && checkboxesValid;

  const isEducationValid =
    !company?.educationalDetail ||
    !!(
      school10.trim() &&
      pass10 &&
      score10.trim() &&
      !score10Error &&
      school12.trim() &&
      pass12 &&
      score12.trim() &&
      !score12Error &&
      bachelorInstitute.trim() &&
      bachelorDegree.trim() &&
      bachelorYear &&
      bachelorScore.trim() &&
      !bachelorScoreError &&
      checkboxesValid
    );

  const isProfessionalSectionValid = !!(
    (noSource ? true : source) &&
    reason &&
    availability &&
    servicing &&
    currentSalary &&
    expectedSalary &&
    (company?.newProffesionalKeys
      ? currentSalary && edTechExperience && remoteWork
      : true)
  );

  const isEverestIMSValid =
    !isEverestIMSFlow ||
    ((noSource || source) &&
      willingToWork5DaysOffice &&
      currentSalary?.toString().trim() &&
      expectedSalary?.toString().trim() &&
      requiredEverestSkills.every((requiredSkill) => {
        const enteredValue = everestSkillExperiences[requiredSkill.skill];
        return (
          enteredValue !== undefined &&
          enteredValue !== "" &&
          isValidDecimalExperience(enteredValue)
        );
      }));

  const isSocketAIValid =
    !isSocketAIFlow ||
    ((noSource || source) &&
      willingToWork5DaysOffice &&
      currentSalary?.toString().trim() &&
      expectedSalary?.toString().trim() &&
      noticePeriod?.toString().trim() &&
      requiredEverestSkills.every((requiredSkill) => {
        const enteredValue = everestSkillExperiences[requiredSkill.skill];
        return (
          enteredValue !== undefined &&
          enteredValue !== "" &&
          isValidDecimalExperience(enteredValue)
        );
      }));

  const isCoverfoxValid = !company?.is_coverfox || !!(
    currentSalary &&
    expectedSalary &&
    availability
  );

  const isZeroharmFlow = !!company?.is_zeroharm;
  const isZeroharmValid = !isZeroharmFlow || !!(
    willingToRelocateHyderabad &&
    willingToWork &&
    comfortable7DayRoster
  );

  const submitDisabled = !(
    isBaseValid &&
    isEducationValid &&
    isEverestIMSValid &&
    isSocketAIValid &&
    isCoverfoxValid &&
    isZeroharmValid
  );

  const disabled =
    !isBaseValid ||
    (company?.professionalDetail && !isProfessionalSectionValid) ||
    (company?.is_coverfox && !isCoverfoxValid) ||
    (isZeroharmFlow && !isZeroharmValid);

  useEffect(() => {
    if (date.length > 0 && time.length > 0) {
      let twelwe_hour_date = new Date();
      let schedule_date = new Date(date);
      let twelwe_hour_time = 0;
      let one_hour_date = new Date();
      let one_hour_time = 0;
      if (parseInt(time) < 12) {
        twelwe_hour_date.setDate(schedule_date.getDate() - 1);
        twelwe_hour_time = Math.abs(parseInt(time)) + 12;
      } else {
        twelwe_hour_date.setDate(schedule_date.getDate());
        twelwe_hour_time = Math.abs(parseInt(time) - 12);
      }
      setTwelveHour(
        `${twelwe_hour_date.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          twelwe_hour_date.toLocaleDateString().split("/")[0],
          2,
        )}-${padWithLeadingZeros(
          twelwe_hour_date.toLocaleDateString().split("/")[1],
          2,
        )} ${padWithLeadingZeros(twelwe_hour_time, 2)}`,
      );
      if (parseInt(time) == 0) {
        one_hour_date.setDate(schedule_date.getDate() - 1);
        one_hour_time = 23;
      } else {
        one_hour_date.setDate(schedule_date.getDate());
        one_hour_time = Math.abs(parseInt(time) - 1);
      }
      setOneHour(
        `${one_hour_date.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          one_hour_date.toLocaleDateString().split("/")[0],
          2,
        )}-${padWithLeadingZeros(
          one_hour_date.toLocaleDateString().split("/")[1],
          2,
        )} ${padWithLeadingZeros(one_hour_time, 2)}`,
      );
    }
  }, [date, time]);

  const [errors, setErrors] = useState({
    pass10: "",
    pass12: "",
    bachelorYear: "",
  });

  // Validate years whenever any change
  useEffect(() => {
    const y10 = parseInt(pass10, 10);
    const y12 = parseInt(pass12, 10);
    const yBach = parseInt(bachelorYear, 10);

    let newErrors = { pass10: "", pass12: "", bachelorYear: "" };

    if (pass10 && pass12 && y10 >= y12) {
      newErrors.pass10 = "10th year must be less than 12th year.";
      newErrors.pass12 = "12th year must be greater than 10th year.";
    }

    if (pass12 && bachelorYear && y12 >= yBach) {
      newErrors.pass12 = newErrors.pass12
        ? newErrors.pass12 +
        " Also, 12th year must be less than Bachelor's year."
        : "12th year must be less than Bachelor's year.";
      newErrors.bachelorYear =
        "Bachelor's year must be greater than 12th year.";
    }

    setErrors(newErrors);
  }, [pass10, pass12, bachelorYear]);

  // Disable options in 12th select that are <= pass10
  const filteredYearOptions12 = pass10
    ? yearOptions.filter((opt) => parseInt(opt.value) > parseInt(pass10))
    : yearOptions;

  // Disable options in bachelor select that are <= pass12
  const filteredYearOptionsBachelor = pass12
    ? yearOptions.filter((opt) => parseInt(opt.value) > parseInt(pass12))
    : yearOptions;
  // Assuming the input format is 'YYYY-MM-DD HH:MM'
  console.log(datePickerId);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${server_API}/v2/job/get/${params.jid}/${params.cid}`)
      .then((response) => {
        console.log(response);
        setJob(response.data);
        setRem1(response.data.firstreminder);
        setRem2(response.data.finalreminder);
        axios
          .get(`${server_API}/v2/company/get/${params.cid}`)
          .then((response) => {
            console.log(response);
            setCompany(response.data);

            // Dynamic Country Handling
            let code = "IN"; // Default to India
            if (
              response.data.company_countries &&
              response.data.company_countries.length > 0
            ) {
              code = response.data.company_countries[0];
            }
            setCompanyCountryCode(code);
            setCountryCode(getPhoneCode(code));
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (job) {
      setJd(job.normaltext);
    }
  }, [job]);

  useEffect(() => {
    if (job?.["location:"]) {
      const locs = job["location:"]
        .split(",")
        .map((l) => l.trim())
        .filter(Boolean);
      if (locs.length === 1) {
        setLocations((prev) => ({ ...prev, preffered: locs }));
      }
    }
  }, [job?.["location:"]]);

  useEffect(() => {
    if (!company?.is_everestIMS && !company?.is_socketAI) {
      setWillingToWork5DaysOffice("");
      setEverestSkillExperiences({});
      return;
    }

    setEverestSkillExperiences((prev) => {
      const next = {};
      requiredEverestSkills.forEach((requiredSkill) => {
        next[requiredSkill.skill] = prev[requiredSkill.skill] || "";
      });
      return next;
    });
  }, [company?.is_everestIMS, company?.is_socketAI, job?.required_skills]);

  useEffect(() => {
    if (company) {
      axios
        .get(`${server_API}/v2/company/geturl/${params.cid}`)
        .then((response) => {
          console.log(response);
          setLogo(response.data.url);
          //   console.log(response.data.url)
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [company]);

  // Meta Pixel Integration for companies with newProffesionalKeys
  useEffect(() => {
    if (company?.newProffesionalKeys && !window.metaPixelInitialized) {
      window.metaPixelInitialized = true;
      // Initialize Meta Pixel
      // eslint-disable-next-line no-unused-expressions
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
      );

      window.fbq("init", "1180284530421432"); // Pixel ID - EC-MSP-Closer_Funnel
      window.fbq("track", "PageView");

      console.log(
        "Meta Pixel initialized: EC-MSP-Closer_Funnel (1180284530421432)",
      );
    }
  }, [company]);

  useEffect(() => {
    if (pin && pin.length === 6) {
      axios
        .get(`https://api.postalpincode.in/pincode/${pin}`)
        .then((res) => {
          const data = res.data?.[0];
          if (data?.Status === "Success" && data?.PostOffice?.length > 0) {
            const details = data.PostOffice[0];
            setCity(details.District || "");
            setState(details.State || "");
            setCountry(details.Country || "India");
            setAddressLookupFailed(false);
          } else {
            setCity("");
            setState("");
            setCountry("");
            setAddressLookupFailed(true);
          }
        })
        .catch((err) => {
          console.error(err);
          setCity("");
          setState("");
          setCountry("");
          setAddressLookupFailed(true);
        });
    } else {
      setAddressLookupFailed(false);
    }
  }, [pin]);

  const addNewApplicant = () => {
    setLoader(true);
    setPopup(true);
    const data = new FormData();
    data.append("resume", resume);
    data.append("jd", jd);
    fetch(`https://interviewguru.co/django/similarity_index`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.status);
        axios
          .post(`${server_API}/v2/applicant/create`, {
            name: fname,
            companyid: params.cid,
            jobid: params.jid,
            totalexperience: `${experience} years`,
            qualification: highestQualification,
            currentJobtitle: jobs,
            currentcomany: companys,
            currentsalary: currentSalary,
            expectedsalary: expectedSalary,
            skillset: skill,
            additionalinfo: addInfo,
            address: `${add1}, ${add2}, ${pin}, ${city}, ${state}, ${country}`,
            email: email,
            educationaldetails: educationDetails,
            preferred_location: Array.isArray(locations.preffered)
              ? locations.preffered.join(",")
              : locations.preffered,
            current_location: locations.current,
            applieddate: "",
            phone: pnum,
            addedby: "",
            coverletter: "",
            resume: "",
            aiscore: 0,
            voiceanalysisscore: 0,
            resumescore: parseInt(data.status),
            firstreminder: d1,
            finalreminder: d2,
            countrycode: countryCode,
            twelvehrwhatsappreminder: twelveHour,
            onehrwhatsappreminder: oneHour,
            timebefore15: Fifteen,
            interviewdate: date,
            interviewtime: `${time}:00`,
          })
          .then((res) => {
            console.log(res);

            setLoader(false);
            setErr(false);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((error) => {
        setLoader(false);
        setErr(false);
        console.log(error);
      });
  };

  const summary = async (flag) => {
    setButtonLoader(true);
    setEmptyRes(false);
    var formdata = new FormData();
    formdata.append("file", resume);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    await fetch(`${server_API}/v2/applicant/resume/summary`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setButtonLoader(false);
        console.log(result);
        if (result.success.Name && !flag) {
          setFname(result.success.Name);
        }
        if (result.success.Email && !flag) {
          setEmail(result.success.Email);
        }
        if (result.success["Phone Number"] && !flag) {
          var phone = result.success["Phone Number"];
          phone = phone.replaceAll("-", "");
          phone = phone.replaceAll(countryCode, "");
          if (phone.startsWith("0")) {
            phone = phone.substring(1);
          }
          setPnum(phone);
        }
        if (result.success["Total Experience"]) {
          setExperience(result.success["Total Experience"]);
        }
        if (result.success.Skills) {
          setskillset(result.success.Skills);
        }
        if (result.success["Highest Qualification"]) {
          setHighestQualification(result.success["Highest Qualification"]);
        }
        setIsParsed(true);
        if (flag) {
          resSave(
            result.success["Total Experience"],
            result.success.Skills,
            result.success["Highest Qualification"],
          );
        }
      })
      .catch((error) => {
        alert(
          "Error: Unsupported File Type. Please upload your resume in PDF format instead of an image.",
        );
        setButtonLoader(false);
        setResume(null);
        setEmptyRes(true);
      });
  };

  useEffect(() => {
    if (companyNames != null && designations != null && skillset != null) {
      console.log(companyNames);
      setCompanys(companyNames[0]);
      setJobs(designations[designations.length - 1]);
      var skil = "";
      skillset.map((s) => {
        console.log(s);
        skil = skil + ", " + s;
      });
      setSkill(skil);
    }
  }, [companyNames, designations, skillset]);
  console.log(isParsed, "parsed");

  useEffect(() => {
    if (admin) {
      setWs("On-Site");
    } else if (editor) {
      setWs("Hybrid");
    } else if (viewer) {
      setWs("Remote");
    }
  }, [admin, editor, viewer]);

  useEffect(() => {
    if (pnum.length > 0) {
      console.log(pnum);
    }
  }, [pnum]);
  const reasonOptions = [
    { value: "Better opportunity", label: "Better opportunity" },
    { value: "Relocation", label: "Relocation" },
    { value: "Higher studies", label: "Higher studies" },
    { value: "Personal reason", label: "Personal reason" },
    { value: "Other", label: "Other" },
  ];

  const noticeOptions = [
    { value: "Immediate", label: "Immediate" },
    { value: "15 days", label: "15 Days" },
    { value: "30 days", label: "30 Days" },
    { value: "60 days", label: "60 Days" },
    { value: "90 days", label: "90 Days" },
  ];

  const normalizeSalary = (val) => {
    if (!val) return "";
    let cleaned = val.trim();

    // Dynamically use the current currency symbol and country code as prefixes to strip
    // e.g. "₹", "INR", "A$", "AUD"
    const prefixes = [curr, companyCountryCode, ...CURRENCY_PREFIXES];

    // repeatedly strip any of those from the start (handles "INR ₹ 1000" etc.)
    let again = true;
    while (again) {
      again = false;
      for (const p of prefixes) {
        if (!p) continue;
        const pattern = new RegExp(
          `^\\s*${p.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\s*`,
          "i",
        );
        if (pattern.test(cleaned)) {
          cleaned = cleaned.replace(pattern, "").trim();
          again = true;
        }
      }
    }

    return cleaned;
  };

  const convertMonthlyToAnnual = (val) => {
    const cleaned = normalizeSalary(val).replace(/,/g, "");
    const monthly = parseFloat(cleaned);
    if (Number.isNaN(monthly)) return normalizeSalary(val);
    return `${monthly * 12}`;
  };

  useEffect(() => {
    if (applicantid.length > 0 && error == true) {
      axios
        .delete(`${server_API}/v2/applicant/delete/${applicantid}`)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [error, applicantid]);

  const resSave = (exp, skills, qual) => {
    if (submitDisabled) {
      toast.error("Please fill all mandatory fields before submitting.", {
        toastId: "everest-required-fields",
        autoClose: 4000,
      });
      return;
    }

    setLoader(true);
    setPopup(true);
    const data = new FormData();
    const shouldAnnualizeCurrentSalary =
      company?.newProffesionalKeys ||
      company?.is_mahindra ||
      company?.is_everestIMS ||
      company?.is_coverfox ||
      company?.is_socketAI;
    const shouldAnnualizeExpectedSalary =
      company?.is_everestIMS ||
      company?.is_coverfox ||
      company?.is_socketAI;
    data.append("name", fname);
    data.append("companyid", job.companyid);
    data.append("totalexperience", exp ? exp : experience);
    data.append("jobid", params.jid);
    data.append("department", job.department);
    data.append(
      "highestqualification",
      company?.from_acfl
        ? highestQualificationACFL
        : qual
          ? qual
          : highestQualification,
    );
    data.append("currentJobtitle", jobs);
    data.append("currentcomany", companys);
    data.append(
      "currentsalary",
      `${curr} ${normalizeSalary(
        shouldAnnualizeCurrentSalary
          ? convertMonthlyToAnnual(currentSalary)
          : currentSalary,
      )}`.trim(),
    );
    data.append(
      "expectedsalary",
      `${curr} ${normalizeSalary(
        shouldAnnualizeExpectedSalary
          ? convertMonthlyToAnnual(expectedSalary)
          : expectedSalary,
      )}`.trim(),
    );
    data.append("skillset", skills ? skills.toString() : skillset.toString());
    data.append("additionalinfo", addInfo);
    data.append(
      "address",
      `${add1}, ${add2}, ${pin}, ${city}, ${state}, ${country}`,
    );
    data.append("email", email);
    data.append("educationaldetails", educationDetails);
    data.append("applieddate", "");
    data.append("phone", pnum);
    data.append("jd", jd);
    data.append("file", resume);
    data.append("aiscore", 0);
    data.append("voiceanalysisscore", 0);
    data.append("firstreminder", d1);
    data.append("heardaboutus", noSource ? "Northstarz" : source);
    data.append("finalreminder", d2);
    data.append("countrycode", countryCode);
    data.append("twelvehrwhatsappreminder", twelveHour);
    data.append("onehrwhatsappreminder", oneHour);
    data.append("interviewdate", date);
    data.append("interviewtime", `${time}:00`);
    data.append(
      "preferred_location",
      Array.isArray(locations.preffered)
        ? locations.preffered.join(",")
        : locations.preffered,
    );
    data.append("current_location", locations.current);
    if (source === "Employees referral") {
      data.append("refferre_name", extraFields.employeeName);
      data.append("employee_id", extraFields.employeeId);
    }
    if (source === "Recruitment agency") {
      data.append("agency_name", extraFields.agencyName);
    }
    if (company?.professionalDetail) {
      data.append("tenthschoolname", school10);
      data.append("tenthscore", score10);
      data.append("tenthyearofpassing", pass10);
      data.append("twelvethschoolname", school12);
      data.append("twelvethscore", score12);
      data.append("twelvethyearofpassing", pass12);
      data.append("institutename", bachelorInstitute);
      data.append("coursename", bachelorDegree);
      data.append("coursefinalscore", bachelorScore);
      data.append("courseyearofpassing", bachelorYear);
      data.append("reasonforchange", reason);
      data.append("isServingNotice", servicing);
      data.append("joiningtime", availability);
    }
    if (company?.is_coverfox) {
      data.append("joiningtime", availability);
    }
    if (company?.newProffesionalKeys) {
      //data.append("willing_to_work_6_days", willingToWork);
      data.append("edtech_experience", edTechExperience);
      data.append("remote_work", remoteWork);
    }
    if (isZeroharmFlow) {
      data.append("willing_to_relocate_hyderabad", willingToRelocateHyderabad);
      data.append("willing_to_work_6_days", willingToWork);
      data.append("comfortable_7_day_roster", comfortable7DayRoster);
    }
    if (company?.from_acfl) {
      data.append("dob", dob);
      data.append("gender", gender);
      data.append("father_name", fatherName);
      data.append("mother_name", motherName);
      data.append("pan_number", pan);
      data.append("voter_id", voterId);
      data.append("driving_license", drivingLicense);
      data.append("equifax_consent", equifaxConsent);
    }
    if (company?.is_everestIMS) {
      const skillExperiencePayload = requiredEverestSkills.reduce(
        (acc, requiredSkill) => {
          const enteredValue = everestSkillExperiences[requiredSkill.skill];
          if (isValidDecimalExperience(enteredValue)) {
            acc[requiredSkill.skill] = parseFloat(enteredValue);
          }
          return acc;
        },
        {},
      );

      data.append("willing_to_work_5_days_office", willingToWork5DaysOffice);
      data.append("skill_experiences", JSON.stringify(skillExperiencePayload));
    }
    if (company?.is_socketAI) {
      const skillExperiencePayload = requiredEverestSkills.reduce(
        (acc, requiredSkill) => {
          const enteredValue = everestSkillExperiences[requiredSkill.skill];
          if (isValidDecimalExperience(enteredValue)) {
            acc[requiredSkill.skill] = parseFloat(enteredValue);
          }
          return acc;
        },
        {},
      );

      data.append("willing_to_work_5_days_office", willingToWork5DaysOffice);
      data.append("skill_experiences", JSON.stringify(skillExperiencePayload));
      data.append("noticeperiod", noticePeriod);
    }

    axios
      .post(`${server_API}/v2/applicant/createnew`, data)
      .then((res) => {
        console.log(res);
        toast.success("Your application is received");

        if (company?.newProffesionalKeys && window.fbq) {
          window.fbq("track", "Lead");
        }

        setLoader(false);
        setErr(false);
        setPopup(false);
        setTab(99);
        setLink(`${baseURL}app/#/data?id=${res.data.success}`);
      })
      .catch((err) => {
        setLoader(false);
        setPopup(false);
        console.log(err);
        toast.error(
          err?.response?.data?.message ||
          "Something went wrong, please try again later!",
          {
            toastId: "error",
            autoClose: 5000,
          },
        );
      });
  };

  const onlyContainsNumbers = (str) => /^[0-9,.]*$/.test(str);

  const inputNum = (event) => {
    const { value } = event.target;
    // Remove any existing commas from the input
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas
      const formattedValue = formatSalary(sanitizedValue, companyCountryCode);

      setCurrentSalary(formattedValue);
    } else {
      setCurrentSalary("");
    }
  };

  const inputExpectedSalary = (event) => {
    const { value } = event.target;
    // Remove any existing commas from the input
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas
      const formattedValue = formatSalary(sanitizedValue, companyCountryCode);

      setExpectedSalary(formattedValue);
    } else {
      setExpectedSalary("");
    }
  };

  const options = [
    { value: "Campus campaign", label: "Campus campaign" },
    { value: "Company website", label: "Company website" },
    { value: "Employees referral", label: "Employees referral" },
    { value: "Naukri", label: "Naukri" },
    { value: "Indeed", label: "Indeed" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Recruitment agency", label: "Recruitment agency" },
    { value: "Others", label: "Others" },
  ].filter((opt) => {
    // Remove "Naukri" if the country is not India
    if (companyCountryCode !== "IN" && opt.value === "Naukri") {
      return false;
    }
    return true;
  });

  const timeOptions = [
    { value: "00", label: "12:00 am" },
    { value: "01", label: "1:00 am" },
    { value: "02", label: "2:00 am" },
    { value: "03", label: "3:00 am" },
    { value: "04", label: "4:00 am" },
    { value: "05", label: "5:00 am" },
    { value: "06", label: "6:00 am" },
    { value: "07", label: "7:00 am" },
    { value: "08", label: "8:00 am" },
    { value: "09", label: "9:00 am" },
    { value: "10", label: "10:00 am" },
    { value: "11", label: "11:00 am" },
    { value: "12", label: "12:00 pm" },
    { value: "13", label: "1:00 pm" },
    { value: "14", label: "2:00 pm" },
    { value: "15", label: "3:00 pm" },
    { value: "16", label: "4:00 pm" },
    { value: "17", label: "5:00 pm" },
    { value: "18", label: "6:00 pm" },
    { value: "19", label: "7:00 pm" },
    { value: "20", label: "8:00 pm" },
    { value: "21", label: "9:00 pm" },
    { value: "22", label: "10:00 pm" },
    { value: "23", label: "11:00 pm" },
  ];
  //   console.log(time);
  //   console.log(source);
  //   console.log(oneHour);
  //   console.log(Fifteen);
  //   console.log(date);
  useEffect(() => {
    if (date && datePickerId) {
      // Convert strings to Date objects
      const firstDate = new Date(date);
      const secondDate = new Date(datePickerId);
      if (firstDate.getTime() == secondDate.getTime()) {
        const currentHour = new Date().getHours();
        const filteredTimeOptions = timeOptions.filter(
          (option) => parseInt(option.value, 10) > currentHour,
        );
        setFilteredTimeOptions(filteredTimeOptions);
      } else {
        setFilteredTimeOptions(timeOptions);
      }
      // Compare the dates
      if (firstDate.getTime() < secondDate.getTime()) {
        setDateFlag(true);
      } else {
        setDateFlag(false);
      }
    }
  }, [date, datePickerId]);

  if (job)
    return (
      <div>
        <div className="bg-cover min-h-screen flex flex-col h-full  bgGradient">
          <img src={logo} className="mt-[35px] mx-auto h-[40px]"></img>
          {tab !== 99 ? (
            <div>
              <div className="bg-white  shadow-lg mt-[32px] mx-4 md:mx-[150px]">
                <div className="bg-white py-6 px-6 flex items-center justify-between">
                  <div>
                    <p className="text-xl font-semibold">{job?.profilename}</p>
                    <p>
                      at{" "}
                      <span className="text-[#148EFF]">
                        <a
                          onClick={() => {
                            window.location.href = company.website;
                          }}
                        >
                          {company?.name}
                        </a>
                      </span>
                    </p>
                    <p className="mt-2 text-sm font-semibold">
                      {job?.jobtype} |
                      {job.workstyle && <span> {job?.workstyle} | </span>}{" "}
                      {job["location:"]}
                    </p>
                  </div>
                  {tab == 0 && (
                    <button
                      onClick={() => {
                        setTab(1);
                      }}
                      className={
                        job.jobstatus == "Open"
                          ? "bg-[#148EFF] text-white py-[10px] px-[16px] rounded-lg"
                          : "hidden"
                      }
                    >
                      Apply Now
                    </button>
                  )}
                </div>
                <div>
                  <div className="h-[0.09rem] bg-gray-300"></div>
                  {tab == 0 && (
                    <div>
                      <div className="py-6 px-6">
                        <div className="md:grid md:grid-cols-2 items-center text-sm justify-start w-full">
                          <p classname="font-semibold  w-1/2 ">
                            <span className="font-semibold">
                              Required Experience:
                            </span>{" "}
                            {job.experience}
                          </p>
                          <p classname="font-semibold ">
                            <span className="font-semibold">Salary:</span>
                            {job.displaysalary
                              ? ` ${curr} ${formatSalary(job.salaryfrom, companyCountryCode)} - ${formatSalary(job.salaryto, companyCountryCode)}`
                              : " undisclosed"}
                          </p>
                        </div>
                        <ReactQuill
                          className="my-[20px] text-sm"
                          value={job.jobdescription}
                          readOnly={true}
                          theme="bubble"
                        ></ReactQuill>
                      </div>
                      <div className="h-[0.09rem] bg-gray-300"></div>
                      <div className="bg-white p-6 text-right">
                        {job.jobstatus == "Open" ? (
                          <button
                            onClick={() => {
                              setTab(1);
                            }}
                            className="bg-[#148EFF] text-white py-[10px] px-[16px] rounded-lg"
                          >
                            Apply Now
                          </button>
                        ) : (
                          <p className="text-red-500 text-center font-semibold">
                            This job is currently closed.
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  {tab == 1 && (
                    <div className="px-6 py-6">
                      <div>
                        <div className="p-5  rounded-xl ">
                          <div className="flex flex-col items space-y-4">
                            <div className="w-full flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
                              {/* Left Section: Inputs */}
                              <div className="w-full md:w-1/2 flex flex-col space-y-4">
                                {/* Full Name */}
                                <div>
                                  <p className="font-semibold">
                                    Full Name{" "}
                                    <span className="text-red-500">*</span>
                                  </p>
                                  <input
                                    style={{ textTransform: "capitalize" }}
                                    onChange={(e) => setFname(e.target.value)}
                                    value={fname}
                                    className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${fnameError && fname.length === 0
                                      ? "border-red-500"
                                      : ""
                                      }`}
                                    type="text"
                                  />
                                  {fnameError && fname.length === 0 && (
                                    <p className="text-sm text-red-500 mt-1">
                                      Name is mandatory
                                    </p>
                                  )}
                                </div>

                                {/* Email */}
                                <div>
                                  <p className="font-semibold">
                                    Email{" "}
                                    <span className="text-red-500">*</span>
                                  </p>
                                  <input
                                    value={email}
                                    onChange={(e) => {
                                      setEmail(e.target.value);
                                      setIsValidEmail(
                                        validateEmail(e.target.value),
                                      );
                                    }}
                                    className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${isValidEmail ||
                                      (emailError && email.length === 0)
                                      ? ""
                                      : "border-red-500"
                                      }`}
                                    type="text"
                                  />
                                  {emailError && email.length === 0 && (
                                    <p className="text-sm text-red-500 mt-1">
                                      Email is mandatory
                                    </p>
                                  )}
                                </div>

                                {/* Phone Number */}
                                <div>
                                  <p className="font-semibold">
                                    WhatsApp No.{" "}
                                    <span className="text-red-500">*</span>
                                  </p>

                                  <div className="flex space-x-3 mt-2">
                                    <select
                                      value={countryCode}
                                      onChange={(e) =>
                                        setCountryCode(e.target.value)
                                      }
                                      className="outline-none border px-2 py-2 rounded-lg bg-white cursor-pointer"
                                    >
                                      {Array.from(new Set(["+91", "+65", "+44", "+1", "+61", "+60", "+63", "+971", countryCode])).filter(Boolean).map((code) => (
                                        <option key={code} value={code}>
                                          {code}
                                        </option>
                                      ))}
                                    </select>

                                    <input
                                      value={pnum}
                                      onChange={(e) => {
                                        const val = e.target.value;

                                        // Allow only digits
                                        if (/^\d*$/.test(val)) {
                                          setPnum(val);
                                        }
                                      }}
                                      className={`w-full outline-none border px-3 py-2 rounded-lg ${pnumError ||
                                        hasCountryCode ||
                                        invalidLength ||
                                        startsWithZero
                                        ? "border-red-500"
                                        : ""
                                        }`}
                                      type="text"
                                      placeholder="Enter phone number"
                                    />
                                  </div>

                                  {/* Validation Messages */}
                                  {hasCountryCode && (
                                    <p className="text-sm text-red-500 mt-1">
                                      The phone number should not contain
                                      country code
                                    </p>
                                  )}
                                  {pnumError && pnum.length === 0 && (
                                    <p className="text-sm text-red-500 mt-1">
                                      Phone number is mandatory
                                    </p>
                                  )}
                                  {invalidLength && (
                                    <p className="text-sm text-red-500 mt-1">
                                      Enter your 10 digit WhatsApp number
                                    </p>
                                  )}
                                  {startsWithZero && !invalidLength && (
                                    <p className="text-sm text-red-500 mt-1">
                                      Phone number should not start with 0
                                    </p>
                                  )}
                                </div>

                                {/* Current Location */}
                                <div>
                                  <p className="font-semibold">
                                    Current Location{" "}
                                    <span className="text-red-500">*</span>
                                  </p>
                                  <input
                                    value={locations.current}
                                    onChange={(e) =>
                                      setLocations({
                                        ...locations,
                                        current: e.target.value,
                                      })
                                    }
                                    className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                    type="text"
                                    placeholder="Enter current location"
                                  />
                                </div>

                                {/* Preferred Location — hidden for single-location jobs (auto-selected via useEffect) */}
                                {(job?.["location:"]?.split(",").filter(Boolean).length !== 1) && (
                                  <div>
                                    <p className="font-semibold">
                                      Preferred Location{" "}
                                      <span className="text-red-500">*</span>
                                    </p>
                                    <Select
                                      isMulti
                                      value={
                                        Array.isArray(locations.preffered)
                                          ? locations.preffered.map((loc) => ({
                                            value: loc,
                                            label: loc,
                                          }))
                                          : []
                                      }
                                      onChange={(selectedOptions) => {
                                        if (
                                          selectedOptions &&
                                          selectedOptions.length > 2
                                        ) {
                                          toast.warning(
                                            "You can select up to 2 locations.",
                                          );
                                          return;
                                        }
                                        setLocations({
                                          ...locations,
                                          preffered: selectedOptions
                                            ? selectedOptions.map(
                                              (opt) => opt.value,
                                            )
                                            : [],
                                        });
                                      }}
                                      options={[
                                        {
                                          value: "Open for All",
                                          label: "Open for All",
                                        },
                                        ...(job?.["location:"]
                                          ? job["location:"]
                                            .split(",")
                                            .map((loc) => ({
                                              value: loc.trim(),
                                              label: loc.trim(),
                                            }))
                                          : []),
                                      ]}
                                      className="w-full mt-1"
                                      placeholder="Select preferred location"
                                    />
                                  </div>
                                )}
                              </div>

                              {/* Right Section: Resume Upload */}
                              <div className="w-full md:w-1/2 flex flex-col space-y-3">
                                <div>
                                  <p className="font-semibold">
                                    Upload CV/Resume{" "}
                                    <span className="text-red-500">*</span>
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    Upload your resume in .pdf, .doc, or .docx
                                    format.
                                  </p>
                                </div>
                                <div
                                  className="w-full h-full border-2 border-dashed border-gray-300 rounded-md p-4 flex flex-col items-center justify-center cursor-pointer"
                                  onDrop={handleDrop}
                                  onDragOver={handleDragOver}
                                  onDragEnter={handleDragEnter}
                                  onClick={() => fileInputRef?.current?.click()}
                                >
                                  {resume ? (
                                    <div className="w-3/4 flex flex-col items-start">
                                      <div className="w-full flex justify-end">
                                        <button onClick={handleDefault}>
                                          <img src={cross} alt="Remove" />
                                        </button>
                                      </div>
                                      <div className="flex items-center gap-2 mt-2">
                                        <img
                                          src={file_upload}
                                          alt="Uploaded file"
                                        />
                                        <span>{resume?.name}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="text-xl font-medium text-[#148EFF]">
                                        Select a file to upload
                                      </span>
                                      <span className="text-sm text-gray-500">
                                        or drag & drop it here
                                      </span>
                                      <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept=".pdf,.doc,.docx"
                                        className="hidden"
                                        onChange={handleFileUpload}
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>

                            {company?.professionalDetail ? (
                              <div className="space-y-6">
                                {/* Row 1 */}
                                {!noSource && (
                                  <div className="flex flex-wrap gap-4 w-full">
                                    <div className="w-1/2">
                                      <div className="flex w-full items-center space-x-1 pb-3">
                                        <p className="font-semibold">
                                          How did you hear about us
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <div className="flex w-full items-end space-x-3">
                                        <div className="w-full">
                                          <Select
                                            value={options.find(
                                              (option) =>
                                                option.value === source,
                                            )}
                                            onChange={(selectedOption) => {
                                              setSource(selectedOption.value);
                                            }}
                                            options={options}
                                            className="w-full "
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex-1 ">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">
                                          Reason for Change
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <Select
                                        value={reasonOptions.find(
                                          (option) => option.value === reason,
                                        )}
                                        onChange={(selectedOption) => {
                                          setReason(
                                            selectedOption
                                              ? selectedOption.value
                                              : "",
                                          );
                                        }}
                                        options={reasonOptions}
                                        className="mt-2"
                                        placeholder="Select Reason"
                                      />
                                    </div>
                                  </div>
                                )}

                                {/* Row 2 */}
                                <div className="flex flex-wrap gap-4">
                                  <div className="flex-1 w-1/2">
                                    <div className="flex items-center space-x-1 pb-1">
                                      <p className="font-semibold">
                                        Time to Join (in days)
                                      </p>
                                      <span className="text-red-500">*</span>
                                    </div>
                                    <input
                                      type="text"
                                      className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                      value={availability}
                                      onChange={(e) =>
                                        setAvailability(e.target.value)
                                      }
                                    />
                                  </div>
                                  <div className="flex-1 w-1/2">
                                    <div className="flex items-center space-x-1 pb-1">
                                      <p className="font-semibold mb-2">
                                        Currently Serving Notice?
                                      </p>
                                      <span className="text-red-500">*</span>
                                    </div>
                                    <div className="flex gap-4">
                                      <button
                                        onClick={() => setServicing("Yes")}
                                        className={`px-4 py-1 rounded-lg border ${servicing === "Yes"
                                          ? "bg-blue-500 text-white"
                                          : "bg-white text-black"
                                          }`}
                                      >
                                        Yes
                                      </button>
                                      <button
                                        onClick={() => setServicing("No")}
                                        className={`px-4 py-1 rounded-lg border ${servicing === "No"
                                          ? "bg-blue-500 text-white"
                                          : "bg-white text-black"
                                          }`}
                                      >
                                        No
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                {/* Row 3 */}
                                <div className="flex flex-wrap gap-4">
                                  <div className="flex-1 w-1/2">
                                    <div className="flex items-center space-x-1 pb-1">
                                      <p className="font-semibold">
                                        {company?.is_everestIMS
                                          ? "Current Monthly Salary"
                                          : "Current Annual CTC"}
                                      </p>
                                      <span className="text-red-500">*</span>
                                    </div>
                                    <input
                                      type="text"
                                      className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                      value={currentSalary}
                                      onChange={(e) => inputNum(e)}
                                    />
                                  </div>

                                  <div className="flex-1 w-1/2">
                                    <div className="flex items-center space-x-1 pb-1">
                                      <p className="font-semibold">
                                        {company?.is_everestIMS
                                          ? "Expected Monthly Salary"
                                          : "Expected Annual CTC"}
                                      </p>
                                      <span className="text-red-500">*</span>
                                    </div>
                                    <input
                                      type="text"
                                      className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                      value={expectedSalary}
                                      onChange={(e) => inputExpectedSalary(e)}
                                    />
                                  </div>
                                </div>
                                {company?.is_socketAI && (
                                  <div className="space-y-4 mb-4">
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">Current Monthly Salary</p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={currentSalary}
                                          onChange={(e) => inputNum(e)}
                                          placeholder="Enter monthly salary"
                                        />
                                      </div>
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">Expected Monthly Salary</p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={expectedSalary}
                                          onChange={(e) => inputExpectedSalary(e)}
                                          placeholder="Enter expected monthly salary"
                                        />
                                      </div>
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">
                                          Are you willing to work from the office?
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <Select
                                        value={
                                          willingToWork5DaysOffice
                                            ? { value: willingToWork5DaysOffice, label: willingToWork5DaysOffice }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setWillingToWork5DaysOffice(selectedOption?.value || "")
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select Yes/No"
                                      />
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">Notice Period (in days)</p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <input
                                        type="text"
                                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                        value={noticePeriod}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          if (/^\d*$/.test(val)) setNoticePeriod(val);
                                        }}
                                        placeholder="Enter notice period in days"
                                      />
                                    </div>
                                    {requiredEverestSkills.map((requiredSkill) => (
                                      <div className="flex-1 w-full" key={`socket-prof-${requiredSkill.skill}`}>
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Years of experience in {requiredSkill.skill}?
                                          </p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={everestSkillExperiences[requiredSkill.skill] || ""}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                                              setEverestSkillExperiences((prev) => ({
                                                ...prev,
                                                [requiredSkill.skill]: value,
                                              }));
                                            }
                                          }}
                                          placeholder="Enter years (e.g. 2)"
                                        />
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {company?.is_everestIMS && (
                                  <div className="space-y-4">
                                    <div className="flex-1 w-full">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">
                                          Are you willing to work from the
                                          office 5 days a week?
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <Select
                                        value={
                                          willingToWork5DaysOffice
                                            ? {
                                              value: willingToWork5DaysOffice,
                                              label: willingToWork5DaysOffice,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setWillingToWork5DaysOffice(
                                            selectedOption?.value || "",
                                          )
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select Yes/No"
                                      />
                                    </div>
                                    {requiredEverestSkills.map(
                                      (requiredSkill) => (
                                        <div
                                          className="flex-1 w-full"
                                          key={`everest-prof-${requiredSkill.skill}`}
                                        >
                                          <div className="flex items-center space-x-1 pb-1">
                                            <p className="font-semibold">
                                              Years of experience in{" "}
                                              {requiredSkill.skill}?
                                            </p>
                                            <span className="text-red-500">
                                              *
                                            </span>
                                          </div>
                                          <input
                                            type="text"
                                            className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                            value={
                                              everestSkillExperiences[
                                              requiredSkill.skill
                                              ] || ""
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (
                                                value === "" ||
                                                /^\d*\.?\d*$/.test(value)
                                              ) {
                                                setEverestSkillExperiences(
                                                  (prev) => ({
                                                    ...prev,
                                                    [requiredSkill.skill]:
                                                      value,
                                                  }),
                                                );
                                              }
                                            }}
                                            placeholder="Enter years (e.g. 2)"
                                          />
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <>
                                {company?.is_coverfox && (
                                  <div className="space-y-4 mb-6">
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">Current CTC</p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={currentSalary}
                                          onChange={(e) => inputNum(e)}
                                          placeholder="Enter current CTC"
                                        />
                                      </div>
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">Expected CTC</p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={expectedSalary}
                                          onChange={(e) => inputExpectedSalary(e)}
                                          placeholder="Enter expected CTC"
                                        />
                                      </div>
                                    </div>
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-full">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">Time to Join (in days)</p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={availability}
                                          onChange={(e) => setAvailability(e.target.value)}
                                          placeholder="Enter days"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {company?.newProffesionalKeys && (
                                  <>
                                    {/* Question 1: Monthly Salary */}
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-full">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            What is your current or last drawn
                                            monthly salary?
                                          </p>
                                          <span className="text-red-500">
                                            *
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={currentSalary}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            if (/^\d*$/.test(val)) {
                                              setCurrentSalary(val);
                                            }
                                          }}
                                          placeholder="Enter monthly salary"
                                        />
                                      </div>
                                    </div>

                                    {/* Question 2: Willing to work 6 days */}
                                    {/* <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-full">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Are you willing to work 6 days a week, including mandatory Saturday & Sunday (weekday off only)?
                                          </p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <Select
                                          value={
                                            willingToWork
                                              ? { value: willingToWork, label: willingToWork }
                                              : null
                                          }
                                          onChange={(selectedOption) =>
                                            setWillingToWork(selectedOption.value)
                                          }
                                          options={[
                                            { value: "Yes", label: "Yes" },
                                            { value: "No", label: "No" },
                                          ]}
                                          className="mt-2"
                                          placeholder="Select Yes/No"
                                        />
                                      </div>
                                    </div> */}

                                    {/* Question 3: EdTech Experience */}
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-full">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Enter your previous work experience
                                            in the EdTech industry?
                                          </p>
                                          <span className="text-red-500">
                                            *
                                          </span>
                                        </div>
                                        <Select
                                          value={
                                            edTechExperience
                                              ? {
                                                value: edTechExperience,
                                                label: edTechExperience,
                                              }
                                              : null
                                          }
                                          onChange={(selectedOption) =>
                                            setEdTechExperience(
                                              selectedOption.value,
                                            )
                                          }
                                          options={[
                                            {
                                              value: "<1 year",
                                              label: "<1 year",
                                            },
                                            {
                                              value: "1-2 years",
                                              label: "1-2 years",
                                            },
                                            {
                                              value: "2-4 years",
                                              label: "2-4 years",
                                            },
                                            {
                                              value: ">4 years",
                                              label: ">4 years",
                                            },
                                          ]}
                                          className="mt-2"
                                          placeholder="Select Experience"
                                        />
                                      </div>
                                    </div>

                                    {/* Question 4: Remote Work Infrastructure */}
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-full">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            You may require to work remotely, do
                                            you have a working laptop and a
                                            stable Wi-Fi connection?
                                          </p>
                                          <span className="text-red-500">
                                            *
                                          </span>
                                        </div>
                                        <Select
                                          value={
                                            remoteWork
                                              ? {
                                                value: remoteWork,
                                                label: remoteWork,
                                              }
                                              : null
                                          }
                                          onChange={(selectedOption) =>
                                            setRemoteWork(selectedOption.value)
                                          }
                                          options={[
                                            { value: "Yes", label: "Yes" },
                                            { value: "No", label: "No" },
                                          ]}
                                          className="mt-2"
                                          placeholder="Select Yes/No"
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                                {company?.is_mahindra && (
                                  <>
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-full">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            What is your current or last drawn
                                            monthly salary?
                                          </p>
                                          <span className="text-red-500">
                                            *
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={currentSalary}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            if (/^\d*$/.test(val)) {
                                              setCurrentSalary(val);
                                            }
                                          }}
                                          placeholder="Enter monthly salary"
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                                {company?.is_socketAI && (
                                  <div className="space-y-4 mb-4">
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Current Monthly Salary
                                          </p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={currentSalary}
                                          onChange={(e) => inputNum(e)}
                                          placeholder="Enter monthly salary"
                                        />
                                      </div>
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Expected Monthly Salary
                                          </p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={expectedSalary}
                                          onChange={(e) => inputExpectedSalary(e)}
                                          placeholder="Enter expected monthly salary"
                                        />
                                      </div>
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">
                                          Are you willing to work from the office?
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <Select
                                        value={
                                          willingToWork5DaysOffice
                                            ? { value: willingToWork5DaysOffice, label: willingToWork5DaysOffice }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setWillingToWork5DaysOffice(selectedOption?.value || "")
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select Yes/No"
                                      />
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">
                                          Notice Period (in days)
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <input
                                        type="text"
                                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                        value={noticePeriod}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          if (/^\d*$/.test(val)) setNoticePeriod(val);
                                        }}
                                        placeholder="Enter notice period in days"
                                      />
                                    </div>
                                    {requiredEverestSkills.map((requiredSkill) => (
                                      <div
                                        className="flex-1 w-full"
                                        key={`socket-basic-${requiredSkill.skill}`}
                                      >
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Years of experience in {requiredSkill.skill}?
                                          </p>
                                          <span className="text-red-500">*</span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={everestSkillExperiences[requiredSkill.skill] || ""}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                                              setEverestSkillExperiences((prev) => ({
                                                ...prev,
                                                [requiredSkill.skill]: value,
                                              }));
                                            }
                                          }}
                                          placeholder="Enter years (e.g. 2)"
                                        />
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {company?.is_everestIMS && (
                                  <div className="space-y-4 mb-4">
                                    <div className="flex flex-wrap gap-4">
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Current Monthly Salary
                                          </p>
                                          <span className="text-red-500">
                                            *
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={currentSalary}
                                          onChange={(e) => inputNum(e)}
                                          placeholder="Enter monthly salary"
                                        />
                                      </div>
                                      <div className="flex-1 w-1/2">
                                        <div className="flex items-center space-x-1 pb-1">
                                          <p className="font-semibold">
                                            Expected Monthly Salary
                                          </p>
                                          <span className="text-red-500">
                                            *
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                          value={expectedSalary}
                                          onChange={(e) =>
                                            inputExpectedSalary(e)
                                          }
                                          placeholder="Enter expected monthly salary"
                                        />
                                      </div>
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="flex items-center space-x-1 pb-1">
                                        <p className="font-semibold">
                                          Are you willing to work from the
                                          office 5 days a week?
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <Select
                                        value={
                                          willingToWork5DaysOffice
                                            ? {
                                              value: willingToWork5DaysOffice,
                                              label: willingToWork5DaysOffice,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setWillingToWork5DaysOffice(
                                            selectedOption?.value || "",
                                          )
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select Yes/No"
                                      />
                                    </div>
                                    {requiredEverestSkills.map(
                                      (requiredSkill) => (
                                        <div
                                          className="flex-1 w-full"
                                          key={`everest-basic-${requiredSkill.skill}`}
                                        >
                                          <div className="flex items-center space-x-1 pb-1">
                                            <p className="font-semibold">
                                              Years of experience in{" "}
                                              {requiredSkill.skill}?
                                            </p>
                                            <span className="text-red-500">
                                              *
                                            </span>
                                          </div>
                                          <input
                                            type="text"
                                            className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                            value={
                                              everestSkillExperiences[
                                              requiredSkill.skill
                                              ] || ""
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (
                                                value === "" ||
                                                /^\d*\.?\d*$/.test(value)
                                              ) {
                                                setEverestSkillExperiences(
                                                  (prev) => ({
                                                    ...prev,
                                                    [requiredSkill.skill]:
                                                      value,
                                                  }),
                                                );
                                              }
                                            }}
                                            placeholder="Enter years (e.g. 2)"
                                          />
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}
                                {isZeroharmFlow && (
                                  <div className="space-y-4 mb-4">
                                    <div className="flex-1 w-full">
                                      <div className="pb-1">
                                        <p className="font-semibold inline">
                                          Are you willing to relocate to Hyderabad to pursue this role?
                                        </p>
                                        <span className="text-red-500 ml-1 inline">*</span>
                                      </div>
                                      <Select
                                        value={
                                          willingToRelocateHyderabad
                                            ? {
                                              value: willingToRelocateHyderabad,
                                              label: willingToRelocateHyderabad,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setWillingToRelocateHyderabad(
                                            selectedOption?.value || "",
                                          )
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                          { value: "Already in Hyderabad", label: "Already in Hyderabad" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select option"
                                      />
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="pb-1">
                                        <p className="font-semibold inline">
                                          This is a full-time onsite role. Are you comfortable working from the office?
                                        </p>
                                        <span className="text-red-500 ml-1 inline">*</span>
                                      </div>
                                      <Select
                                        value={
                                          willingToWork
                                            ? {
                                              value: willingToWork,
                                              label: willingToWork,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setWillingToWork(
                                            selectedOption?.value || "",
                                          )
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select Yes/No"
                                      />
                                    </div>
                                    <div className="flex-1 w-full">
                                      <div className="pb-1">
                                        <p className="font-semibold inline">
                                          ZeroHarm Sciences operates on a 7-day roster-based work schedule. Employees are assigned one weekly off based on business requirements and team availability. Are you comfortable working under this work arrangement?
                                        </p>
                                        <span className="text-red-500 ml-1 inline">*</span>
                                      </div>
                                      <Select
                                        value={
                                          comfortable7DayRoster
                                            ? {
                                              value: comfortable7DayRoster,
                                              label: comfortable7DayRoster,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          setComfortable7DayRoster(
                                            selectedOption?.value || "",
                                          )
                                        }
                                        options={[
                                          { value: "Yes", label: "Yes" },
                                          { value: "No", label: "No" },
                                        ]}
                                        className="mt-2"
                                        placeholder="Select Yes/No"
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="">
                                  {!noSource && (
                                    <>
                                      <div className="flex w-full items-center space-x-1 pb-2">
                                        <p className="font-semibold">
                                          How did you hear about us
                                        </p>
                                        <span className="text-red-500">*</span>
                                      </div>
                                      <div className="flex w-full items-end space-x-3">
                                        <div className="w-full">
                                          <Select
                                            value={options.find(
                                              (option) =>
                                                option.value === source,
                                            )}
                                            onChange={(selectedOption) => {
                                              setSource(selectedOption.value);
                                            }}
                                            options={options}
                                            className="w-full "
                                          />
                                        </div>
                                      </div>

                                      {source === "Employees referral" && (
                                        <div className="flex w-full items-end space-x-3 mt-3">
                                          <div className="w-full">
                                            <div className="flex gap-1">
                                              <p className="font-semibold">
                                                Employee Name
                                              </p>
                                              <span className="text-red-500">
                                                *
                                              </span>
                                            </div>

                                            <div>
                                              <input
                                                className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                                value={extraFields.employeeName}
                                                placeholder="Enter Employee Name"
                                                type="text"
                                                onChange={(e) =>
                                                  setExtraFields({
                                                    employeeName:
                                                      e.target.value,
                                                    employeeId:
                                                      extraFields.employeeId,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>

                                          <div className="w-full">
                                            <div className="flex gap-1">
                                              <p className="font-semibold">
                                                Employee Id
                                              </p>
                                              <span className="text-red-500">
                                                *
                                              </span>
                                            </div>

                                            <div>
                                              <input
                                                className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                                value={extraFields.employeeId}
                                                placeholder="Enter Employee ID"
                                                type="text"
                                                onChange={(e) => {
                                                  setExtraFields({
                                                    employeeName:
                                                      extraFields.employeeName,
                                                    employeeId: e.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {source === "Recruitment agency" && (
                                        <div className="flex w-full items-end space-x-3 mt-3">
                                          <div className="w-full">
                                            <div className="flex gap-1">
                                              <p className="font-semibold">
                                                Agency Name
                                              </p>
                                              <span className="text-red-500">
                                                *
                                              </span>
                                            </div>

                                            <div>
                                              <input
                                                value={extraFields.agencyName}
                                                className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                                placeholder="Enter Agency Name"
                                                type="text"
                                                onChange={(e) =>
                                                  setExtraFields({
                                                    agencyName: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                                <div className="mt-6">
                                  {openInfo
                                    ? acknowledgement.slice(0, 150)
                                    : acknowledgement}
                                  <button
                                    className="text-[#148EFF] font-semibold ml-1"
                                    onClick={() => setOpenInfo(!openInfo)}
                                  >
                                    {openInfo ? "Show more" : "Show less"}
                                  </button>

                                  <div className="mt-5 space-y-3">
                                    <div className="flex items-center space-x-2">
                                      <input
                                        type="checkbox"
                                        onClick={() => setCheckbox1(!checkbox1)}
                                        checked={checkbox1}
                                      />
                                      <p>
                                        I have read and understood the terms of
                                        this consent form and agree to abide by
                                        them.
                                      </p>
                                    </div>

                                    <div className="flex items-center space-x-2">
                                      <input
                                        type="checkbox"
                                        onClick={() => setCheckbox2(!checkbox2)}
                                        checked={checkbox2}
                                      />
                                      <p>
                                        I confirm to receive WhatsApp messages
                                        regarding the job opportunity at{" "}
                                        <strong>{company.name}</strong>.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                        <div className="flex  px-4 py-5 items-center justify-between w-full">
                          <button
                            onClick={() => {
                              setTab(0);
                            }}
                            className="px-6 py-2 rounded-lg text-[#148EFF] border border-[#148EFF] bg-white"
                          >
                            Back
                          </button>
                          <button
                            disabled={disabled}
                            className={
                              !disabled
                                ? "px-6 py-2 text-white bg-[#148EFF] rounded-lg"
                                : "px-6 py-2 text-white bg-gray-400 rounded-lg"
                            }
                            onClick={() => {
                              if (company?.from_acfl) {
                                setTab(3);
                              } else if (company?.professionalDetail) {
                                setTab(2);
                              } else {
                                resSave();
                              }
                            }}
                          >
                            {loader ? (
                              <TailSpin height="30" width="30" color="white" />
                            ) : company?.professionalDetail ||
                              company?.from_acfl ? (
                              "Next"
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {tab == 2 && (
                    <>
                      <div className="px-6 py-6">
                        <h2 className="text-xl font-bold mb-4">
                          Education Info
                        </h2>

                        <div className="grid md:grid-cols-2 gap-4 w-full">
                          {/* 10th School */}
                          <div className="col-span-2">
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                School Name (10th)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <input
                              type="text"
                              className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                              value={school10}
                              onChange={(e) => setSchool10(e.target.value)}
                            />
                          </div>

                          {/* 10th Year of Passing */}
                          <div>
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                Year of Passing (10th)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <Select
                              className="w-full mt-2"
                              value={yearOptions.find(
                                (option) => option.value === pass10,
                              )}
                              options={yearOptions}
                              onChange={(selected) =>
                                setPass10(selected ? selected.value : "")
                              }
                              isClearable={false}
                              placeholder="Select Year"
                            />
                            {errors.pass10 && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.pass10}
                              </p>
                            )}
                          </div>

                          {/* 10th Score */}
                          <div>
                            <div className="flex items-center space-x-1 pb-2">
                              <p className="font-semibold">Score (10th)</p>
                              <span className="text-red-500">*</span>
                            </div>
                            <div className="flex space-x-3 mt-1">
                              <select
                                className="border rounded-lg px-2 py-1"
                                value={scoreType10}
                                onChange={(e) => {
                                  setScoreType10(e.target.value);
                                  // Validate based on new scoreType10 and current score10
                                  setScore10Error(
                                    validateScore(score10, e.target.value),
                                  );
                                }}
                              >
                                <option value="Percentage">%</option>
                                <option value="CGPA">CGPA</option>
                              </select>
                              <input
                                type="text"
                                className={`w-full border px-2 py-1 rounded-lg ${score10Error
                                  ? "border-red-500"
                                  : "border-gray-300"
                                  }`}
                                value={score10}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setScore10(val);
                                  // Validate with the correct scoreType10 value
                                  setScore10Error(
                                    validateScore(val, scoreType10),
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    document
                                      ?.getElementById("score10")
                                      ?.focus();
                                  }
                                }}
                              />
                            </div>
                            {score10Error && (
                              <p className="text-sm text-red-500 mt-1">
                                {score10Error}
                              </p>
                            )}
                          </div>

                          {/* 12th School */}
                          <div className="col-span-2">
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                School Name (12th)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <input
                              type="text"
                              className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                              value={school12}
                              onChange={(e) => setSchool12(e.target.value)}
                            />
                          </div>

                          {/* 12th Year of Passing */}
                          <div className="">
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                Year of Passing (12th)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <Select
                              className="w-full mt-2"
                              value={yearOptions.find(
                                (option) => option.value === pass12,
                              )}
                              options={filteredYearOptions12}
                              onChange={(selected) =>
                                setPass12(selected ? selected.value : "")
                              }
                              isClearable={false}
                              placeholder="Select Year"
                              noOptionsMessage={() =>
                                pass10
                                  ? "Select a year greater than 10th year"
                                  : "No options"
                              }
                            />
                            {errors.pass12 && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.pass12}
                              </p>
                            )}
                          </div>

                          {/* 12th Score */}
                          <div>
                            <div className="flex items-center space-x-1 pb-2">
                              <p className="font-semibold">Score (12th)</p>
                              <span className="text-red-500">*</span>
                            </div>
                            <div className="flex space-x-3 mt-1">
                              <select
                                className="border rounded-lg px-2 py-1"
                                value={scoreType12}
                                onChange={(e) => {
                                  setScoreType12(e.target.value);
                                  // validate with the current score12 value and new scoreType12
                                  setScore12Error(
                                    validateScore(score12, e.target.value),
                                  );
                                }}
                              >
                                <option value="Percentage">%</option>
                                <option value="CGPA">CGPA</option>
                              </select>
                              <input
                                type="text"
                                className={`w-full border px-2 py-1 rounded-lg ${score12Error
                                  ? "border-red-500"
                                  : "border-gray-300"
                                  }`}
                                value={score12}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setScore12(val);
                                  // validate with the new input value and current scoreType12
                                  setScore12Error(
                                    validateScore(val, scoreType12),
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    // Focus to next logical field; adjust id as needed
                                    document
                                      .getElementById("nextInputId")
                                      ?.focus();
                                  }
                                }}
                              />
                            </div>
                            {score12Error && (
                              <p className="text-sm text-red-500 mt-1">
                                {score12Error}
                              </p>
                            )}
                          </div>

                          {/* Bachelor's Institute */}
                          <div className="col-span-2">
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                Name of Institute (Bachelor)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <input
                              type="text"
                              className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                              value={bachelorInstitute}
                              onChange={(e) =>
                                setBachelorInstitute(e.target.value)
                              }
                            />
                          </div>

                          {/* Bachelor's Degree */}
                          <div>
                            <div className="flex items-center space-x-1 pb-1">
                              <p className="font-semibold">Bachelor's Degree</p>
                              <span className="text-red-500">*</span>
                            </div>
                            <input
                              type="text"
                              className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                              value={bachelorDegree}
                              onChange={(e) =>
                                setBachelorDegree(e.target.value)
                              }
                            />
                          </div>

                          {/* Bachelor's Year of Passing */}
                          <div className="">
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                Year of Passing (Bachelor)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <Select
                              className="w-full mt-2"
                              value={yearOptions.find(
                                (option) => option.value === bachelorYear,
                              )}
                              options={filteredYearOptionsBachelor}
                              onChange={(selected) =>
                                setBachelorYear(selected ? selected.value : "")
                              }
                              isClearable={false}
                              placeholder="Select Year"
                              noOptionsMessage={() =>
                                pass12
                                  ? "Select a year greater than 12th year"
                                  : "No options"
                              }
                            />
                            {errors.bachelorYear && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.bachelorYear}
                              </p>
                            )}
                          </div>

                          {/* Bachelor's Score */}
                          <div>
                            <div className="flex items-center space-x-1">
                              <p className="font-semibold">
                                Final Score (Bachelor)
                              </p>
                              <span className="text-red-500">*</span>
                            </div>
                            <div className="flex space-x-3 mt-1">
                              <select
                                className="border rounded-lg px-2 py-1"
                                value={scoreTypeBachelor}
                                onChange={(e) => {
                                  setScoreTypeBachelor(e.target.value);
                                  setBachelorScoreError(
                                    validateScore(
                                      bachelorScore,
                                      e.target.value,
                                    ),
                                  );
                                }}
                              >
                                <option value="Percentage">%</option>
                                <option value="CGPA">CGPA</option>
                              </select>
                              <input
                                id="bachelorScore"
                                type="text"
                                className={`w-full border px-2 py-1 rounded-lg ${bachelorScoreError
                                  ? "border-red-500"
                                  : "border-gray-300"
                                  }`}
                                value={bachelorScore}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setBachelorScore(val);
                                  setBachelorScoreError(
                                    validateScore(val, scoreTypeBachelor),
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    document
                                      .getElementById("reasonDropdown")
                                      ?.focus();
                                  }
                                }}
                              />
                            </div>
                            {bachelorScoreError && (
                              <p className="text-sm text-red-500 mt-1">
                                {bachelorScoreError}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Consent & WhatsApp Checkboxes (unchanged) */}
                        <div className="mt-6">
                          {openInfo
                            ? acknowledgement.slice(0, 150)
                            : acknowledgement}
                          <button
                            className="text-[#148EFF] font-semibold ml-1"
                            onClick={() => setOpenInfo(!openInfo)}
                          >
                            {openInfo ? "Show more" : "Show less"}
                          </button>

                          <div className="mt-5 space-y-3">
                            <div className="flex items-center space-x-1">
                              <input
                                type="checkbox"
                                onClick={() => setCheckbox1(!checkbox1)}
                                checked={checkbox1}
                              />
                              <p>
                                I have read and understood the terms of this
                                consent form and agree to abide by them.
                              </p>
                            </div>

                            <div className="flex items-center space-x-1">
                              <input
                                type="checkbox"
                                onClick={() => setCheckbox2(!checkbox2)}
                                checked={checkbox2}
                              />
                              <p>
                                I confirm to receive WhatsApp messages regarding
                                the job opportunity at{" "}
                                <strong>{company.name}</strong>.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                      <div className="flex  px-4 py-5 items-center justify-between w-full">
                        <button
                          onClick={() => {
                            setTab(1);
                          }}
                          className="px-6 py-2 rounded-lg text-[#148EFF] border border-[#148EFF] bg-white"
                        >
                          Back
                        </button>
                        <button
                          disabled={submitDisabled}
                          className={
                            !submitDisabled
                              ? "px-6 py-2 text-white bg-[#148EFF] rounded-lg"
                              : "px-6 py-2 text-white bg-gray-400 rounded-lg"
                          }
                          onClick={() => {
                            resSave();
                          }}
                        >
                          {loader ? (
                            <TailSpin height="30" width="30" color="white" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </>
                  )}

                  {/* ACFL Step (Tab 3) */}
                  {tab == 3 && (
                    <div className="px-6 py-6">
                      <div className="p-5 rounded-xl">
                        <div className="flex flex-col space-y-4">
                          {/* Row 1: DOB & Gender */}
                          <div className="flex flex-col md:flex-row gap-4 w-full">
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Date of Birth{" "}
                                <span className="text-red-500">*</span>
                              </p>
                              <div className="mt-1">
                                <ModernDatePicker
                                  value={dob ? new Date(dob) : null}
                                  onChange={(date) => {
                                    if (!date) {
                                      setDob("");
                                      return;
                                    }
                                    const y = date.getFullYear();
                                    const m = String(
                                      date.getMonth() + 1,
                                    ).padStart(2, "0");
                                    const d = String(date.getDate()).padStart(
                                      2,
                                      "0",
                                    );
                                    setDob(`${y}-${m}-${d}`);
                                  }}
                                  maxDate={new Date()}
                                  placeholder="DD/MM/YYYY"
                                  dateFormat="dd/MM/yyyy"
                                  showYearNav={true}
                                  inputClassName="!rounded-lg !border-[#d1d5db] !h-auto !py-2"
                                />
                              </div>
                            </div>
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Gender <span className="text-red-500">*</span>
                              </p>
                              <Select
                                value={
                                  gender
                                    ? { value: gender, label: gender }
                                    : null
                                }
                                onChange={(opt) => setGender(opt.value)}
                                options={[
                                  { value: "Male", label: "Male" },
                                  { value: "Female", label: "Female" },
                                  { value: "Other", label: "Other" },
                                ]}
                                className="mt-1"
                                placeholder="Select Gender"
                              />
                            </div>
                          </div>

                          {/* Row 2: Parents Names */}
                          <div className="flex flex-col md:flex-row gap-4 w-full">
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Father's Name{" "}
                                <span className="text-red-500">*</span>
                              </p>
                              <input
                                type="text"
                                className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${fatherNameError ? "border-red-500" : ""}`}
                                value={fatherName}
                                onChange={(e) => {
                                  const val = e.target.value.replace(
                                    /[0-9]/g,
                                    "",
                                  );
                                  setFatherName(val);
                                  if (val.length > 0 && val.length < 5) {
                                    setFatherNameError(
                                      "Father's Name must be at least 5 letters",
                                    );
                                  } else {
                                    setFatherNameError("");
                                  }
                                }}
                                placeholder="Enter Father's Name"
                              />
                              {fatherNameError && (
                                <p className="text-red-500 text-sm mt-1">
                                  {fatherNameError}
                                </p>
                              )}
                            </div>
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Mother's Name{" "}
                                <span className="text-red-500">*</span>
                              </p>
                              <input
                                type="text"
                                className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${motherNameError ? "border-red-500" : ""}`}
                                value={motherName}
                                onChange={(e) => {
                                  const val = e.target.value.replace(
                                    /[0-9]/g,
                                    "",
                                  );
                                  setMotherName(val);
                                  if (val.length > 0 && val.length < 5) {
                                    setMotherNameError(
                                      "Mother's Name must be at least 5 letters",
                                    );
                                  } else {
                                    setMotherNameError("");
                                  }
                                }}
                                placeholder="Enter Mother's Name"
                              />
                              {motherNameError && (
                                <p className="text-red-500 text-sm mt-1">
                                  {motherNameError}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Row 3: Qualification & PAN */}
                          <div className="flex flex-col md:flex-row gap-4 w-full">
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Highest Qualification{" "}
                                <span className="text-red-500">*</span>
                              </p>
                              <Select
                                value={
                                  highestQualificationACFL
                                    ? {
                                      value: highestQualificationACFL,
                                      label: highestQualificationACFL,
                                    }
                                    : null
                                }
                                onChange={(opt) => {
                                  setHighestQualificationACFL(opt.value);
                                  console.log(opt.value);
                                }}
                                options={[
                                  { value: "10th", label: "10th" },
                                  { value: "12th", label: "12th" },
                                  { value: "Diploma", label: "Diploma" },
                                  {
                                    value: "Bachelors/Graduations",
                                    label: "Bachelors/Graduations",
                                  },
                                  {
                                    value: "Masters/Post Graduation",
                                    label: "Masters/Post Graduation",
                                  },
                                  { value: "PhD", label: "PhD" },
                                ]}
                                className="mt-1"
                                placeholder="Select Qualification"
                              />
                            </div>
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                PAN Number{" "}
                                <span className="text-red-500">*</span>
                              </p>
                              <input
                                type="text"
                                className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 uppercase ${panError ? "border-red-500" : ""}`}
                                value={pan}
                                onChange={(e) => {
                                  const val = e.target.value.toUpperCase();
                                  setPan(val);
                                  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                                  if (val.length > 0 && !panRegex.test(val)) {
                                    setPanError(
                                      "Invalid PAN format (e.g., ABCDE1234F)",
                                    );
                                  } else {
                                    setPanError("");
                                  }
                                }}
                                placeholder="Enter PAN Number"
                                maxLength={10}
                              />
                              {panError && (
                                <p className="text-red-500 text-xs mt-1">
                                  {panError}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Row 4: Optional KYC */}
                          <div className="flex flex-col md:flex-row gap-4 w-full">
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Voter ID (Optional)
                              </p>
                              <input
                                type="text"
                                className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                value={voterId}
                                onChange={(e) => setVoterId(e.target.value)}
                                placeholder="Enter Voter ID"
                              />
                            </div>
                            <div className="w-full md:w-1/2">
                              <p className="font-semibold">
                                Driving License (Optional)
                              </p>
                              <input
                                type="text"
                                className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                value={drivingLicense}
                                onChange={(e) =>
                                  setDrivingLicense(e.target.value)
                                }
                                placeholder="Enter Driving License"
                              />
                            </div>
                          </div>

                          {/* Row 5: Permanent Address */}
                          <div className="w-full">
                            <h3 className="font-bold text-lg mb-2">
                              Permanent Address
                            </h3>
                            <div className="grid md:grid-cols-2 gap-4">
                              <div className="col-span-2">
                                <p className="font-semibold">
                                  Address Line 1{" "}
                                  <span className="text-red-500">*</span>
                                </p>
                                <input
                                  type="text"
                                  className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                  value={add1}
                                  onChange={(e) => setAdd1(e.target.value)}
                                  placeholder="House No., Building Name"
                                />
                              </div>
                              <div className="col-span-2">
                                <p className="font-semibold">
                                  Address Line 2 (Optional)
                                </p>
                                <input
                                  type="text"
                                  className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                  value={add2}
                                  onChange={(e) => setAdd2(e.target.value)}
                                  placeholder="Street, Area"
                                />
                              </div>
                              <div>
                                <p className="font-semibold">
                                  Pincode{" "}
                                  <span className="text-red-500">*</span>
                                </p>
                                <input
                                  type="text"
                                  className="w-full outline-none border px-3 py-2 rounded-lg mt-1"
                                  value={pin}
                                  onChange={(e) => {
                                    const val = e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 6);
                                    setPin(val);
                                  }}
                                  placeholder="Enter 6-digit Pincode"
                                  maxLength={6}
                                />
                              </div>
                              <div>
                                <p className="font-semibold">
                                  City <span className="text-red-500">*</span>
                                </p>
                                <input
                                  type="text"
                                  className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${addressLookupFailed ? "" : "bg-gray-100"
                                    }`}
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                  readOnly={!addressLookupFailed}
                                  placeholder="City"
                                />
                              </div>
                              <div>
                                <p className="font-semibold">State</p>
                                <input
                                  type="text"
                                  className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${addressLookupFailed ? "" : "bg-gray-100"
                                    }`}
                                  value={state}
                                  onChange={(e) => setState(e.target.value)}
                                  readOnly={!addressLookupFailed}
                                  placeholder="State"
                                />
                              </div>
                              <div>
                                <p className="font-semibold">Country</p>
                                <input
                                  type="text"
                                  className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${addressLookupFailed ? "" : "bg-gray-100"
                                    }`}
                                  value={country}
                                  onChange={(e) => setCountry(e.target.value)}
                                  readOnly={!addressLookupFailed}
                                  placeholder="Country"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Consent Section */}
                          <div className="mt-6 border p-4 rounded-lg bg-gray-50">
                            <p className="text-sm text-justify mb-4">
                              I, Mr./Mrs.{" "}
                              <strong>
                                {fname || "__________________________"}
                              </strong>{" "}
                              S/O or D/O{" "}
                              <strong>
                                {fatherName || "_______________________"}
                              </strong>
                              , aged about{" "}
                              <strong>
                                {dob
                                  ? Math.floor(
                                    (new Date() - new Date(dob)) /
                                    31557600000,
                                  )
                                  : "______"}
                              </strong>{" "}
                              yrs, having PAN No.{" "}
                              <strong>{pan || "__________________"}</strong>,
                              hereby agree that in connection with my employment
                              with ACFL (Member), I will be subject to
                              background verification, as deemed necessary by
                              ACFL (Member), or its representatives and I hereby
                              authorize and provide my consent to ACFL (Member),
                              and also it’s representative namely Equifax
                              Analytics Pvt. Ltd. (“Equifax”), to verify all the
                              information provided by me including but not
                              limited to my personal information and Sensitive
                              Personal Data or Information, which is already
                              available with Equifax and further authorize
                              Equifax to use the same to generate and deliver
                              the Verification Report to ACFL(Member).
                            </p>
                            <div className="flex items-start space-x-2">
                              <input
                                type="checkbox"
                                id="equifaxConsent"
                                checked={equifaxConsent}
                                onChange={(e) =>
                                  setEquifaxConsent(e.target.checked)
                                }
                                className="mt-1"
                              />
                              <label
                                htmlFor="equifaxConsent"
                                className="text-sm font-semibold cursor-pointer select-none"
                              >
                                I agree to the above background verification
                                consent. <span className="text-red-500">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="bg-[#E9EBFA] h-[0.1rem] w-full mt-6"></div>
                      <div className="flex px-4 py-5 items-center justify-between w-full">
                        <button
                          onClick={() => setTab(1)}
                          className="px-6 py-2 rounded-lg text-[#148EFF] border border-[#148EFF] bg-white"
                        >
                          Back
                        </button>
                        <button
                          disabled={
                            !(
                              dob &&
                              gender &&
                              fatherName &&
                              motherName &&
                              !fatherNameError &&
                              !motherNameError &&
                              highestQualificationACFL &&
                              pan &&
                              !panError &&
                              equifaxConsent &&
                              add1 &&
                              pin &&
                              pin.length === 6 &&
                              city
                            )
                          }
                          className={
                            dob &&
                              gender &&
                              fatherName &&
                              motherName &&
                              !fatherNameError &&
                              !motherNameError &&
                              highestQualificationACFL &&
                              pan &&
                              !panError &&
                              equifaxConsent &&
                              add1 &&
                              pin &&
                              pin.length === 6 &&
                              city
                              ? "px-6 py-2 text-white bg-[#148EFF] rounded-lg"
                              : "px-6 py-2 text-white bg-gray-400 rounded-lg"
                          }
                          onClick={() => {
                            if (
                              Math.floor(
                                (new Date() - new Date(dob)) / 31557600000,
                              ) < 18
                            )
                              alert("You must be at least 18 years old");
                            else resSave(null, null, highestQualificationACFL);
                          }}
                        >
                          {loader ? (
                            <TailSpin height="30" width="30" color="white" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white py-6 text-center shadow-lg mt-[32px] px-3 md:px-0 mx-5 md:mx-[150px]">
              <img src={success} className="h-[200px] mx-auto"></img>
              <p className="mt-[32px] text-center text-[#148EFF] text-2xl font-semibold">
                Your application has been successfully submitted.
              </p>
              <div className="text-black rounded-lg p-4 w-fit mt-4 mx-auto">
                Thank you for your application. Please check your email for next
                steps, ensure to check your spam folders also.
              </div>
              {/* {job?.aiinterviewenabled && !job?.manual_trigger && (
                <div>
                  <p className="mt-[32px] text-xl font-semibold text-center">
                    As next steps, you are required to take an AI Interview
                  </p>
                  <p className="mt-2">
                    <span className="font-semibold">Tip:</span> For a faster
                    hiring process, take your AI interview now.
                  </p>
                  <div className="mt-[32px] flex flex-col  md:w-2/3 items-center mx-auto space-y-4">
                    <button
                      onClick={() => {
                        window.location.href = link;
                      }}
                      className="bg-[#148EFF] text-white rounded-lg py-4 w-full "
                    >
                      Start interview now
                    </button>
                    <button
                      onClick={() => {
                        navigate("/thankyou");
                      }}
                      className="border-[#148EFF] bg-white rounded-lg border text-[#148EFF] py-4 w-full "
                    >
                      Take interview later
                    </button>
                  </div>
                </div>
              )} */}
            </div>
          )}
          <p className="p-5 mt-[33px] text-sm text-center font-semibold">
            Copyright © 2023 Novelio Technologies Pvt. Ltd.
          </p>
        </div>
        <ToastContainer />
      </div>
    );
  else return <div></div>;
};

export default Careers;
